// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultInput_wrapper__AkpAL"};